import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Game as StoryBuilderGame } from "speakid-story-builder";
import "speakid-story-builder/style.css";

import Config from "../../Config";
import PersonalDefaultPage from "../personal/PersonalDefaultPage";

export default function StoryBuilder() {
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod")
      .then((res) => {
        if (res.status === 200 && res.data.status === "not_paid") {
          navigate("/billing/");
        }
      })
      .catch(() => {});
  }, [navigate]);

  return (
    <PersonalDefaultPage>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <StoryBuilderGame config={{ questionsPerRound: 5 }} />
      </div>
    </PersonalDefaultPage>
  );
}
